import { Gb } from "@/components/l10n/Gb.tsx";

export function SizeBytesGb({ value }: { value: number }) {
    return <Gb bytes={value} />;
}
